<template lang="pug">
.action-selector-menu
  GenericCard(:size='size')
    MenuItem(
      v-for='(title, itemValue) in items'
      :key='itemValue'
      @click='setSelectedItem(itemValue)'
      :title='title'
      :selected='itemValue === value'
    )
</template>

<script>
export default {
  props: {
    items: {
      default: () => ({}),
    },
    value: {
      default: '',
    },
    size: {
      default: '33',
    },
  },
  methods: {
    setSelectedItem(value) {
      // console.log(value);
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss">
// .action-selector-menu {}
</style>
